import Settings from '../olr-common/Settings';

export default function HomeworkService($http) {

  this.saveHW = function(hwObj) {
    let url = Settings.backendEnv + "/api/v1/homework";
    var req = {
      method:  "POST",
      url:    url,
      data:   hwObj
    };

    return $http(req);
  };
}



/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-api/HomeworkService.js
 **/